/**
 * SortUp Icon Component
 * 
 * SVG icon for ascending sort indicator
 */

import React from 'react';

const SortUpIcon = ({ size = 12, color = 'currentColor', className = '', ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={`sort-up-icon ${className}`}
      aria-hidden="true"
      {...props}
    >
      <polyline points="17 11 12 6 7 11"></polyline>
      <polyline points="17 18 12 13 7 18"></polyline>
    </svg>
  );
};

export default SortUpIcon;
